<template>
  <div>
    <Users />
    <Users
      v-if="showCounterpartyTable"
      association="Counterparty"
      association-title="Counterparties"
      association-title-singular="Counter Party"
    />
  </div>
</template>

<script>
import Users from './Users'
import { isStandardAccount } from '@/dataAccess/accountTypes'

export default {
  name: 'AccountAdminUsers',
  components: { Users },
  data: function () {
    return {}
  },
  computed: {
    showCounterpartyTable() {
      return isStandardAccount(this.userAccount.type)
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_account'])
    this.mapStates([['userAccount', 'account']])
  },
  async mounted() {
    await this.$store.state.get_accountBinding
  }
}
</script>
